import { useRef, useState, useEffect, useContext } from 'react';
import axios from '../../axios/Axios.js';
import React from 'react';
import AuthContext from "../../context/AuthProvider";
import styles from './Register.module.scss';
import {BrowserView, MobileView} from 'react-device-detect';
import AlertMessage from "../../components/Alert";
import { isAuthenticated, login } from "../../services/auth";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import {
  Link,
  useNavigate,
} from "react-router-dom";
import { useSnackbar } from 'notistack'

const REGISTER_URL = '/register';

function isValidEmail(email) {
  return /\S+@\S+\.\S+/.test(email);
}

function validPassword(password) {
  return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&+=]).{8,}$/.test(password);
}

function Register(props) {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const navigate = useNavigate();
  useEffect(() => {
    document.title = 'Register';
  }, []);
  const [input, setInput] = useState({
    username: '',
    password: '',
    confirmPassword: '',
    terms: false
  });
 
  const [error, setError] = useState({
    username: '',
    password: '',
    confirmPassword: '',
    terms: ""
  })

  const onInputChange = e => {
    const { name, value } = e.target;
    

    if (name === "terms"){
      setInput(prev => ({
        ...prev,
        [name]: e.target.checked
      }));
    } else {
      setInput(prev => ({
        ...prev,
        [name]: value
      }));
    }

    validateInput(e);
  }
 
  const validateInput = e => {
    let { name, value } = e.target;
    setError(prev => {
      const stateObj = { ...prev, [name]: "" };
   
      switch (name) {
        case "username":
          if (!value) {
            stateObj[name] = "Please enter e-mail.";
          } else if (!isValidEmail(value)){
            stateObj[name] = "Invalid e-mail";
          }
          break;
   
        case "password":
          if (!value) {
            stateObj[name] = "Please enter Password.";
          } else if (!validPassword(value)){
            stateObj[name] = "Minimun of 8 characters. Use a combination of uppercase, lowercase, numbers and symbols.";
          } else if (input.confirmPassword && value !== input.confirmPassword) {
            stateObj["confirmPassword"] = "Password and Confirm Password does not match.";
          } else {
            stateObj["confirmPassword"] = input.confirmPassword ? "" : error.confirmPassword;
          }
          break;
   
        case "confirmPassword":
          if (!value) {
            stateObj[name] = "Please enter Confirm Password.";
          } else if (input.password && value !== input.password) {
            stateObj[name] = "Password and Confirm Password does not match.";
          }
          break;
   
        default:
          break;
      }
   
      return stateObj;
    });
  }

  const { setAuth } = useContext(AuthContext);
  const userRef = useRef();
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errMsg, setErrMsg] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    try {
    const response = await axios.post(
        REGISTER_URL,
        { "username": input.username, "password": input.password },
        {
        headers: { "Content-Type": "application/json" },
        // withCredentials: true,
        }
    );
    
    setSuccess(true);
    enqueueSnackbar('Cadastro realizado com sucesso!', { 
      variant: 'success'
    })
    enqueueSnackbar('Confirme o seu e-mail antes de fazer login!', { 
      variant: 'warning'
    })
    navigate('/login');
    } catch (err) {
    if (!err?.response) {
        setErrMsg("No Server Response");
    } else if (err.response?.status === 400) {
        setErrMsg("Missing Username or Password");
    } else if (err.response?.status === 401) {
        setErrMsg("Unauthorized");
    } else {
        setErrMsg("Login Failed");
    }
    }
    setLoading(false);
};

  return (
  <div className={styles.root}>
    <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={loading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
    <BrowserView className={styles.image1}>
    {<img className={styles.image1} src={require('./assets/611e2e6637a49d2d9861a1258d1edf71.png')} alt="alt text" />}
    </BrowserView>
    <div className={styles.box}>
      <div className={styles.flex_col}>
        <img className={styles.image} src={require('./assets/86d5b68e1096185049130f3b34aab905.png')} alt="alt text" />
        <h5 className={styles.highlight}>Crie sua conta:</h5>
        <div className={styles.text}>Comece a utilizar os serviços da Valcann Dashboard</div>

        <form className={styles.flex_col1} onSubmit={handleSubmit}>
          <label className={styles.box1}>
            <div className={styles.info}>
            E-mail
            </div>
          <input
          className={styles.info1}
          type="text"
          name="username"
          onChange={onInputChange}
          value={input.username}
          onBlur={validateInput}
          placeholder="Seu e-mail valcann"
          id="username"
          required
          />
          {error.username && <span className={styles.err}>{error.username}</span>}
          </label>
          <label className={styles.box1}>
            <div className={styles.info}>
            Senha
            </div>
          <input
            className={styles.info1}
            type="password" name="password"
            placeholder="Insira sua senha"
            id="password"
            value={input.password}
            onChange={onInputChange}
            onBlur={validateInput}
            required
          />
          {error.password && <span className={styles.err}>{error.password}</span>}
          </label>
          <label className={styles.box1}>
            <div className={styles.info}>
            Confirmar senha
            </div>
          <input
            className={styles.info1}
            type="password" name="confirmPassword"
            placeholder="Confirmar senha"
            value={input.confirmPassword}
            onChange={onInputChange}
            onBlur={validateInput}
            id="confirmPassword"
            required
          />
          {error.confirmPassword && <span className={styles.err}>{error.confirmPassword}</span>}
          </label>
          <label>
          <div className={styles.divCheckbox}>
          <input type="checkbox"
            name="terms"
            value={input.terms}
            onChange={onInputChange}
            onBlur={validateInput}
            id="terms"
            required
          />
          <p className={styles.textdivCheckbox}>
          Ao criar a conta declaro que aceito os termos, condições e políticas de privacidade
          </p>
          </div>
          {error.terms && <span className={styles.err}>{error.terms}</span>}
          </label>
          <button className={styles.info2} disabled={!input.terms || error.password || error.confirmPassword || error.username || !input.confirmPassword || !input.password || !input.username? "disabled" : ""}>Criar conta</button>
        </form>

        <div className={styles.info3}>
          Já possui uma conta?
          <Link to="/login" className={`${styles.spaceLeft} ${styles.link}`}>Faça login</Link>
        </div>
      </div>
    </div>
  </div>
);
}

export default Register;
